import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, ParamMap, NavigationEnd, Router } from '@angular/router';
import { Observable, Subject, throwError } from 'rxjs';
import { catchError, filter, map } from 'rxjs/operators';

import { PolicyService, Policy } from '@dx/platform-components';
import { faUserShield } from '@fortawesome/pro-light-svg-icons';
import { faFileContract } from '@fortawesome/pro-solid-svg-icons';

import { NavigationService } from '../core/services/navigation.service';

@Component({
  selector: 'dx-policy',
  templateUrl: './policy.component.html',
  styleUrls: ['./policy.component.scss']
})
export class PolicyComponent implements OnInit {
  faUserShield = faUserShield;
  faFileContract = faFileContract;
  routeParams: ParamMap;
  activeTab: string;
  policy$: Observable<Policy>;
  hasError$ = new Subject<boolean>();
  error: any;

  constructor(private router: Router,
    private route: ActivatedRoute,
    private navigationService: NavigationService,
    private policyService: PolicyService) { }

  get policyRoute() {
    return `/policy//${this.activeTab}`;
  }

  ngOnInit() {
    const route = this.navigationService.getRouteByComponent(PolicyComponent);

    if (route) {
      route.paramMap.subscribe(params => {
        this.routeParams = params;
        this.load();
      });
      this.setActiveTab(route);
    }
    // make active tab gets updated on route change (i.e. go to input)
    this.router.events.pipe(
      filter(event => event instanceof NavigationEnd),
      map(() => this.navigationService.getRouteByComponent(PolicyComponent))
    ).subscribe(newRoute => {
      this.setActiveTab(newRoute);
    });
  }


  private setActiveTab(route: ActivatedRoute) {
    if (route && route.firstChild) {
      route.firstChild.url.subscribe(url => {
        this.activeTab = (url.length > 0) ? url[0].path : 'summary';
      });
    }
  }

  private load() {
    this.policy$ = this.policyService.getByPolicyNumber(this.routeParams.get('policyNumber')).pipe(
      catchError(error => {
        this.error = error;
        this.hasError$.next(true);
        return throwError(error);
      })
    );
  }
}
